/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb1_DescriptionInputs */

const en_visa_eb1_description = /** @type {(inputs: Visa_Eb1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The EB-1 category is intended for individuals whose background and accomplishments meet the high standards set for priority workers under U.S. immigration law. Depending on the specific subcategory, it may offer an employment-based path to permanent residence without the labor certification process.`)
};

const pt_visa_eb1_description = /** @type {(inputs: Visa_Eb1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A categoria EB-1 é destinada a indivíduos cuja formação e realizações atendem aos altos padrões estabelecidos para trabalhadores prioritários sob a lei de imigração dos EUA. Dependendo da subcategoria específica, pode oferecer um caminho baseado em emprego para residência permanente sem o processo de certificação trabalhista.`)
};

const es_visa_eb1_description = /** @type {(inputs: Visa_Eb1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La categoría EB-1 está destinada a personas cuya formación y logros cumplen con los altos estándares establecidos para trabajadores prioritarios bajo la ley de inmigración de EE. UU. Dependiendo de la subcategoría específica, puede ofrecer un camino basado en empleo hacia la residencia permanente sin el proceso de certificación laboral.`)
};

/**
* | output |
* | --- |
* | "The EB-1 category is intended for individuals whose background and accomplishments meet the high standards set for priority workers under U.S. immigration la..." |
*
* @param {Visa_Eb1_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb1_description = /** @type {((inputs?: Visa_Eb1_DescriptionInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb1_DescriptionInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb1_description(inputs)
	if (locale === "es") return es_visa_eb1_description(inputs)
	return en_visa_eb1_description(inputs)
});